<template>
  <div class="bagitem accordion-drawer" :class="{'menu-item': isMenuItem}">
    <h3 ref="header" :class="{ '-link': model.action === 'link' }">
      <button
        role="menuitem"
        :aria-expanded="[open && !isClosing]"
        :aria-controls="'section-' + model.name"
        :id="'navTab-' + model.name"
        @click="action()"
        tabindex="0"
        :disabled="drawerDisabled"
      >
        <div class="-ellipsis p-r-18">
          <span class="font-responsive-body">{{ model.name }}</span>
          <transition name="fade">
            <span
              v-if="drawerStatusText"
              v-html="drawerStatusText ? `&nbsp;(${drawerStatusText})` : ''"
            />
            <span
              v-else-if="drawerStatusTextSmall"
              class="font-responsive-smallest"
              style="display: block; margin-top: -2px"
              v-html="drawerStatusTextSmall ? `(${drawerStatusTextSmall})` : ''"
            />
          </transition>
        </div>
        <div class="bagitem-icon" :class="{'-keep-color': keepColor}">
          <!-- DRAWER ICON -->
          <SvgComponent
            :active="iconActive"
            :color="Globals.colors.primary"
            :size="18"
            :icon="{
              name: model.icon,
              color: Globals.colors.black,
              size: 18,
            }"
          />
        </div>
      </button>
    </h3>
    <div
      class="w-100"
      v-bind:class="[open ? openDrawer : closeDrawer]"
      ref="drawer"
    >
      <!-- CONTENT -->
      <component
        v-if="!model.nocomponent"
        :is="model.type"
        :viewed="open && bagOpen"
        @cartCount="onCartCount"
        @on-logged-in="onLogin"
        :ref="model.type"
      ></component>
    </div>
  </div>
</template>
<script>
import { eventBus } from '@/Scripts/lib/helper/eventBus.js';
import { mapState } from 'vuex';
import OpenCloseEvents from '@/Scripts/lib/helper/openCloseHelper';
import siteInfo from '@/Scripts/lib/helper/siteInfo.js';
import SvgComponent from '@/Scripts/components/shared/svg/Svg.vue';

const LoyaltyIcon = () => import('@/Scripts/components/shared/svg/Assets/Loyalty.vue');
const JoinLoyalty = () => import('@/Scripts/components/layout/bag/BagPreviewAssets/JoinLoyalty.vue');
const LoginForm = () => import('@/Scripts/components/form/LoginForm/LoginForm.vue');
const B2CCartContent = () => import('@/Scripts/components/layout/bag/BagPreviewAssets/B2CCartContent.vue');
const B2BReorderCartContent = () => import('@/Scripts/components/layout/bag/BagPreviewAssets/B2BReorderCartContent.vue');
const B2CWishlistContent = () => import('@/Scripts/components/layout/bag/BagPreviewAssets/B2CWishlistContent.vue');

export default {
  mixins: [OpenCloseEvents, siteInfo],
  props: {
    model: Object,
    disabled: Boolean,
    bagOpen: Boolean,
    isMenuItem: Boolean,
    keepColor: {
      type: Boolean,
      default: true
    }

  },
  components: {
    B2CCartContent,
    B2CWishlistContent,
    B2BReorderCartContent,
    JoinLoyalty,
    LoginForm,
    LoyaltyIcon,
    SvgComponent
  },
  data () {
    return {
      open: false,
      isClosing: false,
      openDrawer: '-opened',
      closeDrawer: '-closed',
      drawerStatusText: '',
      drawerStatusTextSmall: '',
      drawerDisabled: false,
      iconActive: false,
      drawerType: 'bagDrawer'
    };
  },
  watch: {
    user: {
      deep: true,
      handler () {
        if (this.model.type === 'LoginForm') {
          const statusName = this.user && this.user.userInformation ? this.user.userInformation.FirstName || this.user.userInformation.Email || '' : '';
          this.drawerStatusText = `<span class="font-responsive-body">${statusName}</span>`;
          this.drawerDisabled = false;
          this.iconActive = true;
        }
      }
    },
    customer: {
      immediate: true,
      handler () {
        if (this.model.type === 'Dashboard') {
          const customer = this.customer ? this.customer.Name : '';
          this.drawerStatusTextSmall = customer;
        }
      }
    }
  },
  computed: {
    ...mapState({
      user: state => state.userInformation,
      isLoggedIn: state => state.appContext.isLoggedIn,
      customer: state => state.b2bCustomer ? state.b2bCustomer.customer : null
    }),
    fullName () {
      if (this.user) {
        return this.user.userInformation.FirstName;
        // return `${this.user.userInformation.FirstName} ${this.user.userInformation.LastName}`;
      }
      return '';
    }
  },
  methods: {
    onLogin () {
      this.getUserData(() => {
        this.$nextTick(() => {
          this.closeIfOpen();
          this.$store.dispatch('appContext/setIsLoggedIn', true);
          this.$store.dispatch('appContext/setIsLoyalty', this.user.userInformation.Personas.Traits.IsLoyaltyMember);
          // console.log(this.user.userInformation);
          this.$set(this.model, 'action', 'link');
          this.$store.dispatch('bag/getCartItems');
        });
      });
    },
    action () {
      if (this.model.action === 'drawer') {
        this.toggle();
      } else if (this.model.action === 'link') {
        this.$set(this.model, 'icon', 'SvgComponent');
        window.location.href = this.getLink(this.model.link);
      }
    },
    onCartCount (cartCount) {
      // console.log(cartCount);
      // if (cartCount < 1) {
      //   this.drawerStatusText = this.insertString('Global', 'Bag', 'EmptyBagMenu');
      //   if (this.model.type !== 'B2CWishlistContent') {
      //     this.drawerDisabled = true;
      //   }
      //   this.iconActive = false;
      //   this.$emit('on-empty-cart');
      //   if (this.open) {
      //     this.toggle();
      //   }
      // } else {
      this.drawerStatusText = `<span class="font-responsive-body">${cartCount}</span><span style="position:absolute;left:-9999px"> items</span>`;
      this.drawerDisabled = false;
      this.iconActive = true;
      // }
    },
    getUserData (callback) {
      this.$store.dispatch('userInformation/getUserInformation').then(() => {
        if (typeof callback === 'function') {
          callback();
        }
      });
    }

  },
  mounted () {
    if (this.model.type === 'Dashboard') {
      this.iconActive = true;
    }
    if (this.model.type === 'LoginForm' && !this.isLoggedIn) {
      this.drawerStatusText = '';
      this.drawerDisabled = false;
      this.iconActive = false;
    }
    if (this.model.type === 'LoginForm' && this.isLoggedIn) {
      this.getUserData();
    }
    if (this.disabled) {
      this.drawerDisabled = true;
    }
  },
  created () {
    eventBus.$on('drawerOpened', (obj) => {
      const type = obj.type;
      const item = obj.item;
      if (type === 'bagDrawer' && item !== this) {
        this.closeIfOpen();
      }
    });
    eventBus.$on('closeAllOpenDrawers', (type) => {
      if (type === 'bagDrawer') {
        this.closeIfOpen();
      }
    });
  }
};
</script>

<style lang="scss" src="@/scss/components/accordion/components.accordion-button.scss"></style>
<style lang="scss">
@import "@/scss/defaults.scss";
.bagitem {
  .-closed {
    display: none;
  }
  h3 > button[disabled="disabled"] {
    pointer-events: none;
  }
  h3.-link > button[aria-expanded="false"] {
    &:hover:not(:disabled) {
      text-decoration: underline;
    }
    &:active {
      text-decoration: none;
    }
  }
  &-icon {
    margin-left: auto;
  }
}
</style>
